module.exports = __webpack_public_path__ + "img/img-8f4d5a.png";